import { render, staticRenderFns } from "./TugBoatArrival.vue?vue&type=template&id=c2009574&"
import script from "./TugBoatArrival.vue?vue&type=script&lang=js&"
export * from "./TugBoatArrival.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports